import React, {Component} from 'react'

import Button from '@material-ui/core/Button'

import PaperBlock from "../../ui/PaperBlock"

/**
 * 	<ControlPanel
 * 		onLoadClick = {content}
 * 	/>
 */

class CategoryScreenControlPanel extends Component {

	render() {

		return <PaperBlock style = {{display: "flex"}}>

			<input
				accept = ".csv"
				style = {{display: "none"}}
				id = "input_file"
				type = "file"
				value = ""
				onClick = {e => {
					e.target.value = ""
				}}
				onChange = {e => {
					if (e.target.files[0]) {
						let fileReader = new FileReader()
						fileReader.onloadend = e => {
							if (typeof this.props.onLoadClick === "function") {
								this.props.onLoadClick(e.target.result)
							}
						}
						fileReader.readAsText(e.target.files[0])
					}
				}}
			/>
			<label htmlFor="input_file">
				<Button component="span">
					Загрузить файл
				</Button>
			</label>

		</PaperBlock>

	}

}

export default CategoryScreenControlPanel
